import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'
const LEASE_OPTIONS = `${PRIVATE_ROOT}/lease-options`

export const RENEWAL = {
  ROOT: `${LEASE_OPTIONS}/renewals`,
  CURRENT_OFFERS: `${LEASE_OPTIONS}/renewals/current-offers`,
  FUTURE_OFFERS: `${LEASE_OPTIONS}/renewals/future-offers`,
  SELECT_OFFER: {
    ROOT: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id`,
    RENTABLE_ITEMS: {
      ROOT: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/rented-items`,
      RENTABLE_ITEMS: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/rentable-items`,
    },
    INCENTIVES: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/incentives`,
    OCCUPANT_INFO: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/occupant-info`,
    ADD_OCCUPANT_INFO: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/add-occupant-info`,
    PERSONAL_INFO: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/personal-info`,
    AUTO_PAYMENTS: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/auto-payments`,
    ADD_AUTO_PAYMENTS: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/add-auto-payments`,
    EDIT_AUTO_PAYMENTS: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/edit-auto-payments/:paymentId`,
    PETS: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/pets`,
    ADD_PET: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/add-pet`,
    EDIT_PET: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/edit-pet/:tempPetId`,
    EMPLOYER_INFO: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/employer-info`,
    ADD_EMPLOYER_INFO: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/add-employer-info`,
    EDIT_EMPLOYER_INFO: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/edit-employer-info/:empId`,
    EMERGENCY_CONTACTS: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/emergency-contacts`,
    ADD_EMERGENCY_CONTACTS: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/add-emergency-contacts`,
    EDIT_EMERGENCY_CONTACTS: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/edit-emergency-contacts/:contactId`,
    ROOMMATE_INTERESTS: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/roommate-interests`,
    AMENITIES: `${LEASE_OPTIONS}/renewals/:offerId/quote-term/:id/amentities`,
    SUCCESS: `${LEASE_OPTIONS}/renewals/success/:id`,
    INSTALLMENT_PLANS: `${LEASE_OPTIONS}/renewals/:offerId/installment-plans/:id`,
  },
  TRANSFER_RENEWAL: {
    ROOT: `${LEASE_OPTIONS}/renewals/transfer`,
    SELECT_UNIT: `${LEASE_OPTIONS}/renewals/transfer/select-unit`,
    SELECTED_UNIT: `${LEASE_OPTIONS}/renewals/transfer-details/selected-unit/:id`,
    /*Renewal Transfer URL refactor for Student Property*/
    SELECT_FLOORPLAN: `${LEASE_OPTIONS}/renewals/transfer/select-floorplan`,
    SELECTED_FLOORPLAN: `${LEASE_OPTIONS}/renewals/transfer-details/selected-floorplan/:id`,
    RENTABLE_ITEMS: {
      ROOT: `${LEASE_OPTIONS}/renewals/transfer/rented-items`,
    },
  },
  RENEWAL_REQUEST: {
    ROOT: `${LEASE_OPTIONS}/renewal-request`,
    ADD_RENEWAL: `${LEASE_OPTIONS}/add-renewal-request`,
    RENEWAL_REQUEST_OPEN: `${LEASE_OPTIONS}/renewal-request-open`,
    RENEWAL_REQUEST_ACCEPTED: `${LEASE_OPTIONS}/renewal-request-accepted`,
    RENEWAL_REQUEST_REJECTED: `${LEASE_OPTIONS}/renewal-request-rejected`,
  },
}
